import React from 'react'
import { BibliographyB1Copy } from '@chegg-wt/core/types/copy'
import { Link } from '@chegg-ui/link'
import { Config } from '@chegg-wt/core/config'
import { UPGRADE_AUTH_MODAL_CTA } from '@chegg-wt/core/components/BibliographyContainer'
import { LvpMarginWrapper } from '../../Layouts/LargeVideoPlayerLayout'
import * as Styled from './styled'

interface Props {
  copy: BibliographyB1Copy
  showAuthModal: boolean
  onUpgradeClick: () => void
}

const BibliographyB1: React.FunctionComponent<Props> = ({
  copy,
  showAuthModal,
  onUpgradeClick,
}) => {
  const UpgradeCTA = ({ onCTAClick }) => {
    if (showAuthModal) {
      return (
        <Styled.Pointer>
          <Link data-test={UPGRADE_AUTH_MODAL_CTA} onClick={onCTAClick}>
            more here
          </Link>
          .
        </Styled.Pointer>
      )
    }
    return (
      <>
        <Link data-test={UPGRADE_AUTH_MODAL_CTA} href={`${Config.baseUrl}/upgrade`}>
          more here
        </Link>
        .
      </>
    )
  }

  return (
    <LvpMarginWrapper>
      <Styled.Container>
        <Styled.HeadingContainer>
          <Styled.ContentHeading>{copy.title}</Styled.ContentHeading>
        </Styled.HeadingContainer>
        <div>
          {copy.contents.map((content) => (
            <React.Fragment key={content.header}>
              <Styled.Header>{content.header}</Styled.Header>
              <Styled.Body>
                {content.body(<UpgradeCTA onCTAClick={onUpgradeClick} />)}
              </Styled.Body>
            </React.Fragment>
          ))}
        </div>
      </Styled.Container>
    </LvpMarginWrapper>
  )
}

export default BibliographyB1
